<div class="activity-summary__container">
    <div class="column " *ngIf="SummaryData">
        <div class="row summary-edit">
            <div class="col-lg-8 activity-summ-title">{{'ActivitySummary' | translate}}</div>
            <div class="col-lg-2">
                <app-button [buttontype]="editButton" (valueChange)="gotoPreviousPage($event)"></app-button>
            </div>
        </div>
        <div class="summery-edit-container">
            <div class="summary-location summary-header" *ngIf="activityName" title="{{activityName}}">
                {{activityName}}
            </div>

            <div class="summary-header" *ngIf="Locations">
                <div class="summary-sub-header">{{'Location' | translate}}</div>
                <div class="summary-sub-text" title={{Locations}}>{{Locations}}</div>
            </div>
            <div class="summary-header" *ngIf="Instructors">
                <div class="summary-sub-header">{{'Instructor' | translate}}</div>
                <div class="summary-sub-text" title={{Instructors}}>{{ Instructors}}</div>
            </div>
            <div class="summary-header">
                <div class="summary-sub-header">{{'CoverSize' | translate}}</div>
                <div class="summary-sub-text" title="{{SummaryData.BookingSize}}">{{SummaryData.BookingSize}}</div>
            </div>
            <div class="summary-header">
                <div class="summary-sub-header">{{'FromDate' | translate}}</div>
                <div *ngIf="selectedClassSchedule.length > 0">
                    {{SummaryData.FromDate | localizeDate: 'DD MMMM YYYY'}}
                </div>
                <div *ngIf="selectedClassSchedule.length == 0">{{(SummaryData.Slots[0].EndTime) ?
                    (SummaryData.Slots[0].EndTime | localizeDate: 'DD MMMM YYYY'):(SummaryData.Slots[0].Date | localizeDate: 'DD MMMM
                    YYYY')}}</div>
            </div>
            <div class="summary-header">
                <div class="summary-sub-header">{{'ToDate' | translate}}</div>
                <div *ngIf="selectedClassSchedule.length > 0">
                    {{SummaryData.ToDate | localizeDate: 'DD MMMM YYYY'}}
                </div>
                <div *ngIf="selectedClassSchedule.length == 0">{{(SummaryData.Slots[SummaryData.Slots.length -
                    1].EndTime) ? (SummaryData.Slots[SummaryData.Slots.length - 1].EndTime | localizeDate: 'DD MMMM YYYY'):
                    (SummaryData.Slots[SummaryData.Slots.length - 1].Date | localizeDate: 'DD MMMM YYYY')}}</div>
            </div>
            <div class="summary-header">
                <div class="summary-sub-header">{{'timeSlots' | translate}}</div>
                <div class="open-booking-summary__item  open-booking-summary__item--slots">
                    <div class="open-booking-summary__item__value" *ngIf="isSessionClass && SelectedTimeSlots">
                        <span
                            *ngFor="let slot of SelectedTimeSlots | slice:0:(showAllSlots ? SelectedTimeSlots.length : 4 ); let index = index;">
                            <span *ngIf="isSessionClass">
                                {{slot.Start | localizeDate: 'DD MMMM, LT'}}
                                -
                                {{slot.End | localizeDate: 'LT'}} &nbsp;</span>
                            <span *ngIf="!isSessionClass">{{slot.Start | localizeDate: 'dDDd MMMM'}}
                                - {{slot.End | localizeDate: 'DD MMMM'}} &nbsp; </span>
                        </span>

                        <div class="open-booking-summary__slots-show-action" *ngIf="SelectedTimeSlots.length > 4"
                            (click)="showAllSlots = !showAllSlots">
                            {{showAllSlots ? 'Show Less' : '+'+(SelectedTimeSlots.length-4)+' '+'more'}}</div>

                    </div>

                    <div class="open-booking-summary__item__value" *ngIf="!isSessionClass && selectedClassSchedule">

                        <ng-container *ngFor="let selectedDay of selectedClassSchedule; let index = index;">
                            <div class="selected-class-schedule__row" *ngIf="selectedDay">
                                <div class="selected-class-schedule__day">
                                    {{dayOfWeek[index]}}
                                </div>
                                <div class="selected-class-schedule__session-period-list">
                                    <div class="selected-class-schedule__session-period-item"
                                        *ngFor="let slot of selectedDay;">
                                        <span>{{slot.Start | localizeDate: 'LT'}} - {{slot.End | localizeDate: 'LT'}}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>


                    </div>
                    <div class="open-booking-summary__item__value" *ngIf="OpenbookingSlots">
                        <div class="open-booking-summary__item__value">
                            <span
                                *ngFor="let slot of OpenbookingSlots | slice:0:(showAllSlots ? OpenbookingSlots.length : 4 ); let index = index;">
                                {{slot.LocalTime | localizeDate: 'LT'}}
                                - {{slot.EndTime | localizeDate: 'LT'}}{{OpenbookingSlots[index+1] && ','}}
                                &nbsp;
                            </span>
                        </div>
                        <div class="open-booking-summary__slots-show-action" *ngIf="OpenbookingSlots.length > 4"
                            (click)="showAllSlots = !showAllSlots">
                            {{showAllSlots ? 'Show Less' : '+'+(OpenbookingSlots.length-4)+' '+'more'}}
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="rate-plan-summary">
            <div class="open-booking-summary__rate-plan"
                *ngIf="ratePlan && ratePlan.RatePlanCalculations  && ratePlan.TotalRatePlan">
                <div class="open-booking-summary__section-title">
                    {{'rates' | translate}}
                </div>
                <mat-accordion
                    *ngFor="let slot of ratePlan.SlotList | slice:0:(showRatePalns ? ratePlan.SlotList?.length : 4 ); let index= index;">
                    <mat-expansion-panel [expanded]="index == 0"
                        class="open-booking-summary__summary-accordian--panel open-booking-summary__summary-accordian--rate-plan">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="open-booking-summary__section-title--accordian">
                                <span *ngIf="isSessionClass && activityService.bookingSection$.value">
                                    {{slot.TimeRange.Start | date:'dd MMMM, hh:mm a' }} - {{slot.TimeRange.End |
                                    date:'hh:mm
                                    a'}}
                                </span>
                                <span *ngIf="!isSessionClass && activityService.bookingSection$.value">
                                    {{slot.TimeRange.Start | localizeDate: 'DD MMMM' }} - {{slot.TimeRange.End | localizeDate: 'DD MMMM'}}
                                </span>
                                <span *ngIf="!activityService.bookingSection$.value">
                                    {{slot.TimeRange.Start | localizeDate: 'LT' }} - {{slot.TimeRange.End | localizeDate: 'LT'}}
                                </span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="open-booking-summary__rate-row" *ngIf="slot.RatePlanVariants?.TotalBaseRate">
                            <div class="open-booking-summary__rate-label">
                                <span class="open-booking-summary__rate-label--main">{{'TotalBaseRate' |
                                    translate}}</span>
                            </div>
                            <div class="open-booking-summary__rate">{{OperationCurrency}}
                                {{slot.RatePlanVariants.TotalBaseRate | currencyDecimalFormatter
                                }}</div>
                        </div>
                        <div class="open-booking-summary__rate-row" *ngIf="slot.RatePlanVariants?.LocationVariant">
                            <div class="open-booking-summary__rate-label">
                                <span class="open-booking-summary__rate-label">{{'LocationVariant' | translate}} <span
                                        class="sub-text">({{'forTotalOf' | translate}}
                                        {{activityService.SessionBookingObj?.BookingSize}}
                                        )</span>
                                </span>
                            </div>
                            <div class="open-booking-summary__rate">{{OperationCurrency}}
                                {{slot.RatePlanVariants.LocationVariant | currencyDecimalFormatter}}</div>
                        </div>
                        <div class="open-booking-summary__rate-row" *ngIf="slot.RatePlanVariants?.InstructorVariant">
                            <div class="open-booking-summary__rate-label">
                                <span class="open-booking-summary__rate-label">{{'InstructorVariant' | translate}}<span
                                        class="sub-text">({{'forTotalOf' | translate}}
                                        {{activityService.SessionBookingObj?.BookingSize}}
                                        )</span></span>
                            </div>
                            <div class="open-booking-summary__rate">{{OperationCurrency}}
                                {{slot.RatePlanVariants.InstructorVariant | currencyDecimalFormatter}}</div>
                        </div>
                        <div class="open-booking-summary__rate-row"
                            *ngIf="slot.bookingTypeVariants && slot.bookingTypeVariants.length">
                            <div class="open-booking-summary__rate-label">
                                <span class="open-booking-summary__rate-label sub-label">{{'BookingType' | translate}}
                                </span>
                            </div>
                        </div>
                        <div class="open-booking-summary__rate-row" *ngFor="let variant of slot.bookingTypeVariants">
                            <div class="open-booking-summary__rate-label" *ngIf="variant.Variant">
                                <span class="open-booking-summary__rate-label--main">{{variant.BookingTypeName}}</span>
                                <span class="open-booking-summary__rate-label--sub">{{variant.bookingTypes}}</span>
                            </div>
                            <div class="open-booking-summary__rate">{{OperationCurrency}} {{variant.Variant | currencyDecimalFormatter}}</div>
                        </div>
                        <div class="open-booking-summary__rate-row"
                            *ngIf="slot.coverTypeVariants && slot.coverTypeVariants.length">
                            <div class="open-booking-summary__rate-label">
                                <span class="open-booking-summary__rate-label sub-label">{{'coverType' | translate}}
                                </span>
                            </div>
                        </div>
                        <div class="open-booking-summary__rate-row" *ngFor="let variant of slot.coverTypeVariants">
                            <div class="open-booking-summary__rate-label" *ngIf="variant.Variant">
                                <span class="open-booking-summary__rate-label--main">{{variant.CoverTypeName}}</span>
                                <span class="open-booking-summary__rate-label--sub">{{variant.covers}}</span>
                            </div>
                            <div class="open-booking-summary__rate">{{OperationCurrency}} {{variant.Variant | currencyDecimalFormatter}}</div>
                        </div>

                        <div class="open-booking-summary__rate-row" *ngIf="slot.MemberShipVariant">
                            <div class="open-booking-summary__rate-label">
                                <span class="open-booking-summary__rate-label--main">{{'MemberShipVariant' |
                                    translate}}</span>
                            </div>
                            <div class="open-booking-summary__rate">{{OperationCurrency}} {{slot.MemberShipVariant |
                                currencyDecimalFormatter}}
                            </div>
                        </div>
                        <div class="open-booking-summary__rate-row open-booking-summary__rate-total">
                            <div class="open-booking-summary__rate-label">
                                <span class="open-booking-summary__rate-label--main">{{'TotalSessionCharge' |
                                    translate}}</span>
                            </div>
                            <div class="open-booking-summary__rate">{{OperationCurrency}}
                                {{slot.TotalAmount | currencyDecimalFormatter}}</div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
                <div class="open-booking-summary__slots-show-action" *ngIf="ratePlan.SlotList.length > 4"
                    (click)="showRatePalns = !showRatePalns">
                    {{showRatePalns ? 'Show Less' : '+'+(ratePlan.SlotList.length-4)+' '+'more'}}</div>
                <div class="open-booking-summary__rate-row open-booking-summary__total">
                    <div class="open-booking-summary__rate-label">
                        <span class="open-booking-summary__rate-label">{{'total' | translate}}</span>
                    </div>
                    <div class="open-booking-summary__rate">{{OperationCurrency}} {{ratePlan.TotalRatePlan !== null ?
                        (ratePlan.TotalRatePlan | currencyDecimalFormatter) : '0.00'}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>